export interface NamedRecord {
  id: number
  name: string
}

export interface SelectOption {
  label: string
  value: number
}

export const toSelectOption = (record: NamedRecord): SelectOption => ({
  label: record.name,
  value: record.id
})
